/**
 * Generated by orval 🍺
 * Do not edit manually.
 * ZonHub
 * Project management for Solar
 * OpenAPI spec version: 1.0.0
 */
import type {
	MutationFunction,
	QueryClient,
	UseMutationOptions,
	UseMutationResult,
} from "@tanstack/react-query"
import { useMutation } from "@tanstack/react-query"

import type {
	KYCVerificationDocumentResponse,
	KycVerificationDocument,
} from "../@types"

import { apiWithTokenAuth } from "../../api"

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1]

export const getUsersKycDocumentsUploadCreateUrl = (userUuid: string) => {
	return `/users/${userUuid}/kyc_documents_upload/`
}

export const usersKycDocumentsUploadCreate = async (
	userUuid: string,
	kycVerificationDocument: KycVerificationDocument,
	options?: Parameters<typeof apiWithTokenAuth>[1],
): Promise<KYCVerificationDocumentResponse> => {
	const formData = new FormData()
	formData.append(`full_first_name`, kycVerificationDocument.full_first_name)
	formData.append(`document_type`, kycVerificationDocument.document_type)
	formData.append(`expiry_date`, kycVerificationDocument.expiry_date)
	formData.append(`document`, kycVerificationDocument.document)
	if (kycVerificationDocument.document_back !== undefined) {
		formData.append(`document_back`, kycVerificationDocument.document_back)
	}

	return apiWithTokenAuth<KYCVerificationDocumentResponse>(
		getUsersKycDocumentsUploadCreateUrl(userUuid),
		{
			...options,
			method: "POST",
			body: formData,
		},
	)
}

export const getUsersKycDocumentsUploadCreateMutationKey = () =>
	["usersKycDocumentsUploadCreate"] as const

export const getUsersKycDocumentsUploadCreateMutationOptions = <
	TError = unknown,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof usersKycDocumentsUploadCreate>>,
		TError,
		UsersKycDocumentsUploadCreateMutationVariables,
		TContext
	>
	request?: SecondParameter<typeof apiWithTokenAuth>
}): UseMutationOptions<
	Awaited<ReturnType<typeof usersKycDocumentsUploadCreate>>,
	TError,
	UsersKycDocumentsUploadCreateMutationVariables,
	TContext
> => {
	const mutationKey = getUsersKycDocumentsUploadCreateMutationKey()
	const { mutation: mutationOptions, request: requestOptions } = options
		? options.mutation &&
			"mutationKey" in options.mutation &&
			options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey }, request: undefined }

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof usersKycDocumentsUploadCreate>>,
		UsersKycDocumentsUploadCreateMutationVariables
	> = (props) => {
		const { userUuid, data } = props ?? {}

		return usersKycDocumentsUploadCreate(userUuid, data, requestOptions)
	}

	return { mutationFn, ...mutationOptions }
}

export type UsersKycDocumentsUploadCreateMutationResult = NonNullable<
	Awaited<ReturnType<typeof usersKycDocumentsUploadCreate>>
>
export type UsersKycDocumentsUploadCreateMutationBody = KycVerificationDocument
export type UsersKycDocumentsUploadCreateMutationError = unknown
export type UsersKycDocumentsUploadCreateMutationVariables = {
	userUuid: string
	data: KycVerificationDocument
}

export const useUsersKycDocumentsUploadCreate = <
	TError = unknown,
	TContext = unknown,
>(
	options?: {
		mutation?: UseMutationOptions<
			Awaited<ReturnType<typeof usersKycDocumentsUploadCreate>>,
			TError,
			UsersKycDocumentsUploadCreateMutationVariables,
			TContext
		>
		request?: SecondParameter<typeof apiWithTokenAuth>
	},
	queryClient?: QueryClient,
): UseMutationResult<
	Awaited<ReturnType<typeof usersKycDocumentsUploadCreate>>,
	TError,
	UsersKycDocumentsUploadCreateMutationVariables,
	TContext
> => {
	return useMutation(
		getUsersKycDocumentsUploadCreateMutationOptions(options),
		queryClient,
	)
}
